// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.memo(props => JsxRuntime.jsxs(Stack.make, {
  children: [
    JsxRuntime.jsx(Title.make, {
      children: props.title.toUpperCase(),
      level: 5
    }),
    JsxRuntime.jsx(Stack.make, {
      children: props.children,
      space: "xsmall"
    })
  ],
  space: "normal"
}));

export {
  make,
}
/* make Not a pure module */
